module.exports = __webpack_public_path__ + "media/images/getcrowd_b_n_w-4dcc0535de473e479ff6fe5fa4d557fc.jpg";